window.addEventListener('load', ()=>{
    function urlSplit(url) {
        let url_short
        if (url.includes('?')) {
            let urlsplit = url.split('?');
            return url_short = urlsplit[0];
        }else{
            return url_short = url;
        }
    }
    
    /* Helper function to get original variant ID for outlet products */
    function getOriginalVariantIdQV(originalVariantIdsString, barcode) {
        if (!originalVariantIdsString || !barcode) {
            return null;
        }
        
        try {
            // Parse string format: [{SKU1:ID1},{SKU2:ID2},]
            const cleanString = originalVariantIdsString.replace(/[\[\]]/g, '').replace(/,$/, '');
            
            if (!cleanString) {
                return null;
            }
            
            const mappings = cleanString.split('},{');
            
            for (let mapping of mappings) {
                const cleanMapping = mapping.replace(/[{}]/g, '');
                const parts = cleanMapping.split(':');
                
                if (parts.length === 2) {
                    const sku = parts[0].trim();
                    const variantId = parts[1].trim();
                    
                    if (sku === barcode) {
                        return variantId;
                    }
                }
            }
            
            console.warn('[Outlet Product - QV] SKU not found in original variant mappings:', barcode);
            return null;
        } catch (error) {
            console.error('[Outlet Product - QV] Error parsing original variant IDs:', error);
            return null;
        }
    }
    
    function calculatePercentageDiscount(product_variant, quickview_product, hasPromo, iProductUrl) {
        let iVariantFirst = product_variant.id;
        let iVariantFirstTitle = product_variant.title;
        let iVariantFirstComparePrice = product_variant.compare_at_price;
        let iVariantFirstPrice = product_variant.price;
        var iVariantFirstComparePriceTotal = iVariantFirstComparePrice > iVariantFirstPrice ? iVariantFirstComparePrice : '';
        var iVariantFirstTag = iVariantFirstComparePrice > iVariantFirstPrice ? Math.ceil((((iVariantFirstComparePrice - iVariantFirstPrice ) * 100.0)/ iVariantFirstComparePrice)) : '';
        
        // Check if this is an outlet product and get the original variant ID
        var finalVariantId = iVariantFirst;
        var isOutlet = quickview_product.find('.js-button-quickview').attr('data-is-outlet');
        
        if (isOutlet === 'true') {
            var originalVariantIds = quickview_product.find('.js-button-quickview').attr('data-original-variant-ids');
            var originalVariantId = getOriginalVariantIdQV(originalVariantIds, product_variant.barcode);
            
            if (originalVariantId) {
                finalVariantId = originalVariantId;
                console.log('[Outlet Product - QV] Using original variant ID:', originalVariantId, 'for outlet variant:', iVariantFirst);
            } else {
                console.warn('[Outlet Product - QV] Could not find original variant ID, using outlet variant ID as fallback');
            }
        }
        
        quickview_product.find('.js-button-quickview').attr('data-product-variant-id', finalVariantId).attr('data-selected-outlet-variant', iVariantFirst).attr('data-product-quantity', 1).attr('data-product-compare', iVariantFirstComparePriceTotal).attr('data-product-tag', iVariantFirstTag ).attr('data-has-promo', hasPromo);
        quickview_product.find('.js-button-product-view').attr('href', iProductUrl + '?variant=' + iVariantFirst);
        quickview_product.find('[data-product-price]').empty().append(new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(iVariantFirstPrice/100));
        // Discounts
        if (iVariantFirstComparePrice > iVariantFirstPrice) {
            quickview_product.find('[data-product-price-old]').removeClass('d-none').empty().append(new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(iVariantFirstComparePriceTotal/100));
            quickview_product.find('.js-product-price-tag').removeClass('d-none')
            quickview_product.find('[data-product-price-tag]').empty().append(iVariantFirstTag);
        }else{
            quickview_product.find('[data-product-price-old]').addClass('d-none');
            quickview_product.find('.js-product-price-tag').addClass('d-none');
        }
        quickview_product.find('[data-product-option-selected]').empty().append(iVariantFirstTitle);
    }
    /* QuickView - Collections */
    /* -------------------------------------------------------------------------------------- */
    let hasPromo
    $('body').on('click', '.js-quickview-product', function(event) {
        console.log(event)
        event.preventDefault();
        event.stopPropagation();
        document.querySelector('body').style.overflow = 'hidden'
        const productCategory = event.currentTarget.dataset.productCategory
        const quickViewContainer = document.querySelector('#quickviewProduct');
        const quickViewAddToCart = quickViewContainer.querySelector('[data-product-category]')
        quickViewAddToCart.dataset.productCategory = productCategory
        var el = $(this),
            product_url = el.attr('data-product-url'),
            quickview_product = $('#quickviewProduct'),
            tmpl_clean = quickview_product.find('.js-quickview-clean')
            
        hasPromo = el.data('has-promo');
        // Reset Quickview
        quickview_product.find('[data-product-price-old]').addClass('d-none');
        quickview_product.find('.js-product-price-tag').addClass('d-none');
        tmpl_clean.empty();
        // Get information product
        var url_new = urlSplit(product_url);
        $.getJSON(url_new+'.js', function(product) {
            let iProductCurrent = product.id;
            let iProductTitle = product.title;
            let iProductVendor = product.vendor;
            let iProductUrl = product.url;
            let iProductImage = "url('" + product.featured_image + "&width=780')";
            let iProductPrice = product.price / 100;
            let iProductVariants = product.variants;
            let iProductOptions = product.options;
            let iProductAvailable = product.available;
            let iOptionNameHTML = '';
            let iOptionNameHTMLColor = '';
            // Get variants
            if ( iProductOptions.length >= 1 ) {
                for(let i = 0; i < iProductOptions.length; i++){
                    let iOptionsHTML = '';
                    let iOption = '';
                    if ( iProductVariants.length >= 1 ) {
                        let countAvailable = false;
                        for(let y = 0; y < iProductVariants.length; y++){
                            if (iProductVariants[y].available == true && countAvailable == false) {
                                // Set product variants
                                iOption = '<div class="s-quickview__link js-quickview-get-variant active" data-position="'+ iProductOptions[i].position +'" data-value="'+ iProductVariants[y].title +'" data-product-id="'+ iProductUrl +'"><span class="s-quickview__value">' + iProductVariants[y].title + '</span></div>';
                                iOptionsHTML = iOptionsHTML + iOption;
                                // First variant available
                                countAvailable = true;
                                calculatePercentageDiscount(iProductVariants[y], quickview_product, hasPromo, iProductUrl);
                            }else {
                                // First variant available when product out of stock
                                if (y == 0) {
                                    calculatePercentageDiscount(iProductVariants[0], quickview_product, hasPromo, iProductUrl);
                                }
                                // Set product variants
                                let iVariantFirst = iProductVariants[0].id;
                                quickview_product.find('.js-button-product-view').attr('href', iProductUrl+'?variant=' + iVariantFirst);
                                iOption = '<div class="s-quickview__link js-quickview-get-variant '+ iProductVariants[y].available +'" data-position="'+ iProductOptions[i].position +'" data-value="'+ iProductVariants[y].title +'" data-product-id="'+ iProductUrl +'"><span class="s-quickview__value">' + iProductVariants[y].title + '</span></div>';
                                iOptionsHTML = iOptionsHTML + iOption;
                            }
                        }
                        // Render variants
                        let iItemsHTML = '<div class="s-quickview__items s-quickview__items--' + iProductOptions[i].name + ' mb-p15">' +
                                            iOptionsHTML +
                                        '</div>';
                        iOptionNameHTML = iOptionNameHTML +  iItemsHTML;
                    }
                }
            }
            // Enable or Diseable buttons
            if (iProductAvailable != true) {
                $('#quickviewProduct').find('.js-button-quickview').addClass('c-button--disabled').attr('disabled', 'disabled"');
                $('#quickviewProduct').find('[data-add-to-cart-text]').text('Agotado');
            }else{
                $('#quickviewProduct').find('.js-button-quickview').removeClass('c-button--disabled').removeAttr('disabled', 'disabled"').attr('data-has-promo', hasPromo);
                $('#quickviewProduct').find('[data-add-to-cart-text]').text('Agregar al carrito');
            }
            // Template
            quickview_product.find('.js-error-message-content').removeClass('active');
            quickview_product.find('[js-product-grid-qv-promo-item]').append(iProductTitle);
            quickview_product.find('[data-product-title]').append(iProductTitle);
            quickview_product.find('[data-product-vendor]').append(iProductVendor);
            quickview_product.find('[data-product-thumb]').append('<div class="s-quickview__image" style="background: white '+ iProductImage +'no-repeat center center; background-size: cover;" role="img" aria-label="'+ iProductTitle +'"></div>');
            quickview_product.find('[data-product-options]').append(iOptionNameHTML);
            quickview_product.addClass('active');
        });
    });

    /* QuickView - Select variant */
    /* -------------------------------------------------------------------------------------- */
    $('#quickviewProduct').on('click', '.js-quickview-get-variant', function(event) {
        event.preventDefault();
        event.stopPropagation();
        var el = $(this),
            idProduct = el.attr('data-product-id'),
            listVariants = $('.js-quickview-get-variant'),
            quickview_product = $('#quickviewProduct');
        // Reset variants
        el.addClass('active');
        el.siblings('.js-quickview-get-variant').removeClass('active');
        quickview_product.find('.js-button-quickview').removeClass('c-button--disabled').removeAttr('disabled');
        quickview_product.find('[data-product-price-text]').addClass('d-none');
        quickview_product.find('[data-product-invalid]').addClass('d-none');
        quickview_product.find('.js-error-message-content').removeClass('active');
        quickview_product.find('[data-product-price-old]').addClass('d-none');
        quickview_product.find('.js-product-price-tag').addClass('d-none');
        quickview_product.find('.js-product-option-content').removeClass('active');
        // Variant to look for 
        var option = [];
        for (var i = 0; i < listVariants.length; i++) {
            if ($(listVariants[i]).hasClass('active')) {
                var position = $(listVariants[i]).attr('data-position');
                for (var j = 1; j < listVariants.length; ++j) {
                    if (position == j) {
                        option[j] = $(listVariants[i]).attr('data-value');
                    }
                }
            }
        }
        // Get information product
        $.getJSON(idProduct+'.js', function(product) {
            var iProductVariants = product.variants;
            var iProductUrl = product.url;
            // Search for matches in product options
            var currentVariant = _.find(iProductVariants, function (o) {
                return o.option1 == option[1] && o.option2 == option[2] && o.option3 == option[3];
            });
            // Options not found
            if (currentVariant === undefined) {
                quickview_product.find('[data-product-invalid]').removeClass('d-none');
                quickview_product.find('.js-button-quickview').addClass('c-button--disabled').attr('disabled', 'disabled"');
                quickview_product.find('[data-add-to-cart-text]').text('Agotado');
            }else {
                // Options found
                $('[data-product-invalid]').addClass('d-none');
                // All variants
                calculatePercentageDiscount(currentVariant, quickview_product, hasPromo, iProductUrl);
                // Enable or Diseable buttons
                var qVariantAvailable = currentVariant.available;
                if (qVariantAvailable == false) {
                    quickview_product.find('.js-button-quickview').addClass('c-button--disabled').attr('disabled', 'disabled"');
                    quickview_product.find('[data-add-to-cart-text]').text('Agotado');
                    quickview_product.find('[data-product-price-text]').removeClass('d-none');
                }else {
                    quickview_product.find('.js-button-quickview').removeClass('c-button--disabled').removeAttr('disabled');
                    quickview_product.find('[data-add-to-cart-text]').text('Agregar al carrito');
                    quickview_product.find('[data-product-price-text]').addClass('d-none');
                    
                }
            }
        });
    });
    /* QuickView - Open Select variant mobile */
    /* -------------------------------------------------------------------------------------- */
    $('#quickviewProduct').on('click', '.js-product-option-content', function(event) {
        event.preventDefault();
        /* Act on the event */
        var el = $(this);
        el.addClass('active');
        $('.s-quickview__wrapper').animate({
          scrollTop: el.offset().top - 144,
        });
    });
});


